<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Assunto:"
    id="selectAssunto"
    placeholder="Selecione o(s) Assunto(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import AssuntoRepository from '@/shared/http/repositories/configurations/assunto.js'

export default {
  name: 'NxSelectAjuizamentoAssunto',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadAssuntos()
  },
  methods: {
    onLoadAssuntos () {
      AssuntoRepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.id, 'text': x.nome}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Assuntos', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectAjuizamentoAssunto.vue